import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "影视资讯", to: "/category/film-news" },
  { label: "娱乐新闻", to: "/category/entertainment-news" },
  { label: "电影推荐", to: "/category/movie-recommend" },
  { label: "电视剧更新", to: "/category/tv-update" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Navbar() {
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = keyword.trim();
    if (!trimmed) return;
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
    setMenuOpen(false);
    setKeyword("");
  };

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 gap-4">
          {/* 品牌 */}
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-heart-3-fill text-background-50 text-lg" />
            </span>
            <span className="font-heading text-xl font-black text-foreground-950 whitespace-nowrap">
              红桃网
            </span>
          </Link>

          {/* 桌面导航 */}
          <nav className="hidden lg:flex items-center gap-1 flex-1 justify-center">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(link.to)
                    ? "text-primary-600 font-semibold bg-primary-50"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* 搜索 */}
          <form
            onSubmit={submitSearch}
            className="hidden md:flex items-center gap-2 shrink-0"
          >
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视、娱乐资讯"
                className="w-44 lg:w-56 pl-9 pr-3 py-2 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
              />
            </div>
            <button
              type="submit"
              className="px-4 py-2 text-sm rounded-full bg-primary-500 text-background-50 font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              搜索
            </button>
          </form>

          {/* 移动端汉堡 */}
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开菜单"
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>

        {/* 移动端展开面板 */}
        {menuOpen && (
          <div className="lg:hidden pb-4 space-y-3">
            <form onSubmit={submitSearch} className="flex items-center gap-2">
              <div className="relative flex-1">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索影视、娱乐资讯"
                  className="w-full pl-9 pr-3 py-2.5 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
                />
              </div>
              <button
                type="submit"
                className="px-4 py-2.5 text-sm rounded-full bg-primary-500 text-background-50 font-medium whitespace-nowrap cursor-pointer"
              >
                搜索
              </button>
            </form>
            <div className="grid grid-cols-2 gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMenuOpen(false)}
                  className={`px-3 py-2.5 text-sm rounded-lg text-center whitespace-nowrap transition-colors ${
                    isActive(link.to)
                      ? "bg-primary-50 text-primary-600 font-semibold"
                      : "bg-background-100 text-foreground-700"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}